import parallax from "../../plugins/parallax.js";
import isMobile from "./is-mobile.js";
import _ua from "./is-ua";

var userAgent = window.navigator.userAgent.toLowerCase();

if (!(userAgent.indexOf("trident") >= 0 || userAgent.indexOf("msie") >= 0)) {
  if (!_ua().Mobile && !_ua().Tablet) {
    if (!isMobile(768)) {
      parallax.init();
    }
  }
} else {
}
